<template>
  <div class="content">
    <div class="row">
      <div class="col-sm-2">
        <base-input placeholder="검색어" v-model="searchWord">
          <span slot="helpBlock" class="form-text" />
        </base-input>
      </div>
      <div class="col-sm-2">
        <base-button @click="getData(searchWord)" type="default">검색</base-button>
      </div>
      <div class="col-sm-2">
        <el-select @change="getData()" class="select-primary col-md-12 text-left" size="large" placeholder="선택" v-model="type">
          <el-option v-for="option in types" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
        </el-select>
      </div>
      <div class="col-sm-6 text-right">
        <base-button @click="setVisibleOrder" type="default">노출 순서 변경</base-button>
        <base-button @click="goTemplateForm" type="default">템플릿 만들기</base-button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 text-left">검색 {{ data.length }} 개 / 총 {{ count }} 개</div>
    </div>
    <hr />

    <div class="row">
      <div class="col-sm-1">아이디</div>
      <div class="col-sm-2">제목</div>
      <div class="col-sm-6">내용</div>
      <div class="col-sm-1">템플릿 타입</div>
      <div class="col-sm-2">관리</div>
    </div>
    <hr />
    <draggable handle=".handle" v-model="data" @start="drag = true" @end="drag = false">
      <div class="row handle template-table" v-for="(item, index) in data">
        <div class="col-sm-1">{{ item.id }}</div>
        <div class="col-sm-2">{{ item.title }}</div>
        <div class="col-sm-6 template-contents">{{ item.contents }}</div>
        <div class="col-sm-1">{{ item.type }}</div>
        <div class="col-sm-2">
          <base-button @click.native="goTemplateForm(item.id)" type="warning" size="sm"> 수정 </base-button>
          <base-button @click.native="removeTemplate(item, index)" type="warning" size="sm"> 삭제 </base-button>
        </div>
      </div>
    </draggable>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import { BaseInput } from "@/components/index";
import swal from "sweetalert2";
import draggable from "vuedraggable";
import { TemplateTypes } from "@/pages/TemplateManage/TemplateType";

export default {
  components: {
    BaseInput,
    draggable,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  async created() {
    await this.getData();
  },
  data() {
    return {
      data: [],
      count: null,
      searchWord: null,
      type: null,
      types: [{ label: "전체", value: null }, ...TemplateTypes],
      totalPage: null,
    };
  },
  methods: {
    async getData(searchWord) {
      const params = {};
      params.type = this.type;
      if (searchWord) {
        params.searchWord = searchWord;
      }

      await this.$axios.get("/templates", { params }).then((res) => {
        this.count = res.data.data.count;
        this.data = res.data.data.data.map((d) => {
          d.type = TemplateTypes.map((t) => {
            if (t.value === d.type) {
              return t.label;
            } else {
              return null;
            }
          })
            .filter((t) => t !== null)
            .toString();
          return d;
        });
      });
    },
    async removeTemplate(row, index) {
      if (row.id) {
        swal
          .fire({
            title: "삭제 확인",
            text: `${row.title} 템플릿을 삭제하시겠습니까?`,
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: "btn btn-danger btn-fill",
            cancelButtonClass: "btn btn-cancel btn-fill",
            confirmButtonText: "삭제",
            cancelButtonText: "취소",
            buttonsStyling: false,
          })
          .then(async (selection) => {
            if (selection.value) {
              return this.$axios.delete(`/templates/${row.id}`).then((res) => {
                window.Toast.success("삭제되었습니다");
                this.getData();
              });
            }
          });
      } else {
        this.data.splice(index, 1);
      }
    },
    async goTemplateForm(id) {
      if (id) {
        await this.$router.push(`/template/templateForm?id=${id}`);
      } else {
        await this.$router.push(`/template/templateForm`);
      }
    },
    async setVisibleOrder() {
      const templates = [];
      this.data.forEach((item, order) => {
        templates.push({ id: item.id, order });
      });
      return this.$axios.put("/templates/order", { templates }).then((res) => {
        Toast.success("노출순서가 변경되었습니다");
        this.getData();
      });
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
.template-table {
  margin-bottom: 15px;
}
.template-contents {
  white-space: pre-wrap;
  text-align: left;
  max-height: 60px;
  overflow-y: auto;
}
</style>
